var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.705 4.62998C14.6253 4.334 14.4693 4.06413 14.2526 3.84739C14.0359 3.63065 13.766 3.47464 13.47 3.39498C12.38 3.09998 8.00001 3.09998 8.00001 3.09998C8.00001 3.09998 3.62001 3.09998 2.53001 3.39498C2.23403 3.47464 1.96417 3.63065 1.74743 3.84739C1.53069 4.06413 1.37468 4.334 1.29501 4.62998C1.09148 5.74161 0.992717 6.86989 1.00001 7.99998C0.992717 9.13006 1.09148 10.2583 1.29501 11.37C1.37468 11.666 1.53069 11.9358 1.74743 12.1526C1.96417 12.3693 2.23403 12.5253 2.53001 12.605C3.62001 12.9 8.00001 12.9 8.00001 12.9C8.00001 12.9 12.38 12.9 13.47 12.605C13.766 12.5253 14.0359 12.3693 14.2526 12.1526C14.4693 11.9358 14.6253 11.666 14.705 11.37C14.9085 10.2583 15.0073 9.13006 15 7.99998C15.0073 6.86989 14.9085 5.74161 14.705 4.62998ZM6.60001 10.1V5.89998L10.235 7.99998L6.60001 10.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.12255d24c5449af25569875415d6c243.svg";
export { ForwardRef as ReactComponent };